import { IntlContextConsumer, changeLocale } from 'gatsby-plugin-intl';
import styled from 'styled-components';

import { StyledSelect } from './ProvinceSelector';

const LanguageOption = styled.option`
  text-transform: uppercase;
`;

const LanguageToggleV2 = () => {
  const onLangChange = (event: { target: { value: string; }; }) => {
    const selectedLanguage = event.target.value;
    changeLocale(selectedLanguage);
  };
  return (
    <IntlContextConsumer>
      {({ languages, language }) => (
        <div data-testid="LanguageToggleV2">
          <StyledSelect
            aria-label={language === "fr" ? "Sélecteur de langue" : "Language Selector"}
            data-testid="lang-select"
            value={language}
            onChange={onLangChange}
          >
            {languages.map(lang => <LanguageOption key={lang} value={lang}>{lang}</LanguageOption>)}
          </StyledSelect>
        </div>
      )}
    </IntlContextConsumer>
  );
};

export default LanguageToggleV2;

/*
Component handles changing between locales
*/
